import { LocalizedPageTitle, LocalizedParagraph, ModalWrapper, NewModalBodyWrapper } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { Banner, Stack } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { EnterpriseListTable } from './components/EnterpriseListTable';

export const GuestExperienceEnterpriseList = () => (
    <ModalWrapper>
        <NewModalBodyWrapper padded>
            <Stack vertical spacing="200">
                <LocalizedPageTitle textKey={TextKey.WhitelistedUserEmailsEnterprisesPageTitle} />
                <LocalizedParagraph textKey={TextKey.WhitelistedUserEmailsEnterprisesSubTitle} />
                <Banner
                    variant="info"
                    primaryText={lt(TextKey.WhitelistedUserEmailsEnterprisesBannerTitle)}
                    secondaryText={lt(TextKey.WhitelistedUserEmailsEnterprisesBannerBody)}
                />
                <EnterpriseListTable />
            </Stack>
        </NewModalBodyWrapper>
    </ModalWrapper>
);
